import { translate, translateFormatter } from '@/domains/core/localization/translate';
export const seeMore = translateFormatter<{
  number: number;
  isMax: boolean;
}>([{
  "type": 0,
  "value": "See all products "
}, {
  "type": 5,
  "value": "isMax",
  "options": {
    "true": {
      "value": [{
        "type": 0,
        "value": "(+500)"
      }]
    },
    "false": {
      "value": [{
        "type": 0,
        "value": "("
      }, {
        "type": 1,
        "value": "number"
      }, {
        "type": 0,
        "value": ")"
      }]
    }
  }
}], undefined, undefined, "en");
export const {
  title
} = translate({
  "title": "Products"
});